import { useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "../App.scss";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../theme";

import SignIn from "../pages/Signin/SignIn";
import ForgetPassword from "../pages/Signin/ForgetPassword";

import Candidates from "../pages/Job/Candidates";
import JobDashboard from "../pages/JobDashboard/JobDashboard";
import EditJob from "../pages/Job/EditJob";
import JobList from "../pages/Job/JobList";

import EventSummary from "../pages/Dashboard/EventSummary";
import Summary from "../pages/Dashboard/Summary";
import Events from "../pages/Event/Events";
import EditEvent from "../pages/Event/EditEvent";
import EventList from "../pages/Event/EventList";

import ChangePassword from "../pages/Settings/ChangePassword";

import UserTable from "../pages/User/UserTable";
import UserDetails from "../pages/User/UserDetails";

import EmailSender from "../pages/Email/EmailSender";

const ProtectedRoute = ({
  user,
  next,
  children,
}: {
  user: any;
  next: string;
  children: any;
}) => {
  if (user) {
    return children;
  }

  return <Navigate to={`/signin?next=${next}`} replace />;
};

const AppRoutes = () => {
  const { userInfo } = useSelector((state: any) => state.userDetails);
  return (
    <Router>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Navigate to="/signin" replace />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signin/forget-password" element={<ForgetPassword />} />

          {/* Protected Routes */}
          {/* Users */}
          <Route
            path="/users"
            element={
              <ProtectedRoute user={userInfo} next="/users">
                <UserTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user/:userId/edit"
            element={
              <ProtectedRoute user={userInfo} next="/user/:userId/edit">
                <UserDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/email-sender"
            element={
              <ProtectedRoute user={userInfo} next="/email-sender">
                <EmailSender />
              </ProtectedRoute>
            }
          />

          {/* Jobs */}
          <Route
            path="/jobs"
            element={
              <ProtectedRoute user={userInfo} next="/jobs">
                <Candidates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-list"
            element={
              <ProtectedRoute user={userInfo} next="/job-list">
                <JobList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job/edit"
            element={
              <ProtectedRoute user={userInfo} next="/job/edit">
                <EditJob />
              </ProtectedRoute>
            }
          />

          {/* Events */}
          <Route
            path="/events"
            element={
              <ProtectedRoute user={userInfo} next="/events">
                <Events />
              </ProtectedRoute>
            }
          />
          <Route
            path="/event-list"
            element={
              <ProtectedRoute user={userInfo} next="/event-list">
                <EventList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/event/edit"
            element={
              <ProtectedRoute user={userInfo} next="/event/edit">
                <EditEvent />
              </ProtectedRoute>
            }
          />

          {/* Dashboard */}
          <Route
            path="/dashboard/event-summary"
            element={
              <ProtectedRoute user={userInfo} next="/dashboard/event-summary">
                <EventSummary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-dashboard"
            element={
              <ProtectedRoute user={userInfo} next="/job-dashboard">
                <JobDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/summary"
            element={
              <ProtectedRoute user={userInfo} next="/summary">
                <Summary />
              </ProtectedRoute>
            }
          />

          {/* Settings */}
          <Route
            path="/settings/change-password"
            element={
              <ProtectedRoute user={userInfo} next="/settings/change-password">
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>
      </ThemeProvider>
    </Router>
  );
};

export default AppRoutes;
